import { Translations } from '../../contexts/Lang.context'
import { TrKey } from './trKey.cnst'

// prettier-ignore
export const TRANSLATIONS_SE: Translations = {
    // Generic
    [TrKey.name]: 'Namn',
    [TrKey.emailAddress]: 'Mailadress',
    [TrKey.cancel]: 'Avbryt',
    [TrKey.save]: 'Spara',
    [TrKey.saving]: 'Sparar...',
    [TrKey.list]: 'Lista',
    [TrKey.grid]: 'Rutnät',
    [TrKey.add]: 'Lägg till',
    [TrKey.delete]: 'Radera',
    [TrKey.remove]: 'Ta bort',
    [TrKey.edit]: 'Redigera',
    [TrKey.create]: 'Skapa',
    [TrKey.title]: 'Titel',
    [TrKey.date]: 'Datum',
    [TrKey.summary]: 'Summering',
    [TrKey.image]: 'Bild',
    [TrKey.breadText]: 'Brödtext',
    [TrKey.publish]: 'Publicera',
    [TrKey.day]: 'dag',
    [TrKey.week]: 'vecka',
    [TrKey.size]: 'Storlek',
    [TrKey.type]: 'Typ',
    [TrKey.select]: 'Välj',
    [TrKey.close]: 'Stäng',
    [TrKey.done]: 'Klar',
    [TrKey.somethingWentWrong]: 'Något gick fel!',
    [TrKey.new]: 'Ny',
  
    // Weekdays
    [TrKey.weekdayMondayPlural]: 'måndagar',
    [TrKey.weekdayTuesdayPlural]: 'tisdagar',
    [TrKey.weekdayWednesdayPlural]: 'onsdagar',
    [TrKey.weekdayThursdayPlural]: 'torsdagar',
    [TrKey.weekdayFridayPlural]: 'fredagar',
    [TrKey.weekdaySaturdayPlural]: 'lördagar',
    [TrKey.weekdaySundayPlural]: 'söndagar',
  
    // Navbar
    [TrKey.navbarItemUsers]: 'Användare',
    [TrKey.navbarItemCourses]: 'Utbildningar',
    [TrKey.navbarItemBlog]: 'Nyhetsflöde',
    [TrKey.navbarItemCalendar]: 'Kalender',
    [TrKey.navbarItemSponsors]: 'Sponsorer',
    [TrKey.navbarItemDashboard]: 'Hemsida',
    [TrKey.navbarItemMedia]: 'Filer',
    [TrKey.navbarItemAdministrators]: 'Administratörer',
    [TrKey.navbarItemAccount]: 'Kontoinställningar',
    [TrKey.navbarItemLogout]: 'Logga ut',
    [TrKey.navbarMenu]: 'Meny',
    [TrKey.navbarItemECommerce]: 'E-handel',
  
    // Dashboard
    [TrKey.dashboardWebsite]: 'Hemsida',
    [TrKey.editWebsite]: 'Redigera sida',
    [TrKey.freeTierBannerText]: 'Du använder en gratisversion av Atlas Cloud som löper ut {date}. <a class="underline" href="mailto:info@bucketmedia.se">Kontakta oss</a> för att teckna ett avtal.',
    [TrKey.showLiveWebsite]: 'Visa sidan live',
    [TrKey.deployStatusBuilding]: 'Uppdaterar',
    [TrKey.deployStatusReady]: 'Publicerad',
    [TrKey.deployStatusError]: 'Uppdateringen misslyckades',
    [TrKey.deployStatusPending]: 'Laddar...',
  
    // Account
    [TrKey.accountSettings]: 'Kontoinställningar',
    [TrKey.accountChangePassword]: 'Byt lösenord',
    [TrKey.accountUpdateInfo]: 'Ändra uppgifter',
    [TrKey.accountUpdateDisclaimer]: 'När du uppdaterar din kontoinformation så måste du logga in på nytt.',
    [TrKey.accountNameDescription]: 'För- och efternamn',
    [TrKey.accountNamePlaceholder]: 'Förnamn Efternamn',
    [TrKey.accountEmailDescription]: 'Mailadressen du använder för att logga in',
    [TrKey.accountCurrentPassword]: 'Nuvarande lösenord',
    [TrKey.accountNewPassword]: 'Nytt lösenord',
    [TrKey.accountNewPasswordRepeat]: 'Upprepa nytt lösenord',
    [TrKey.accountCurrentPasswordDescription]: 'Det lösenord du har för närvarande',
    [TrKey.accountNewPasswordDescription]: 'Välj ett nytt starkt lösenord',
    [TrKey.accountNewPasswordRepeatDescription]: 'Se till att lösenorden stämmer överens',
    [TrKey.accountPasswordRequirements]: 'Lösenordskrav',
    [TrKey.accountPasswordRequirementsItem1]: 'Minst 8 tecken',
    [TrKey.accountPasswordRequirementsItem2]: 'Minst en liten bokstav',
    [TrKey.accountPasswordRequirementsItem3]: 'Minst en stor bokstav',
    [TrKey.accountPasswordRequirementsItem4]: 'Minst en siffra',
    [TrKey.accountFailedToUpdatePassword]: 'Kunde inte uppdatera lösenord',
    [TrKey.accountCheckPasswords]: 'Kontrollera lösenorden',
    [TrKey.accountSignInAgain]: 'Logga in på nytt',
    [TrKey.accountPasswordUpdated]: 'Lösenord uppdaterat',
    [TrKey.accountPasswordsDoNotMatch]: 'Lösenorden matchar inte',
    [TrKey.accountFailedToUpdateInfo]: 'Kunde inte uppdatera uppgifter',
    [TrKey.accountUpdatedInfo]: 'Uppgifter uppdaterade',
  
    // Sponsors
    [TrKey.sponsor]: 'Sponsor',
    [TrKey.sponsors]: 'Sponsorer',
    [TrKey.sponsorsSearchPlaceholder]: 'Sök sponsorer',
    [TrKey.sponsorsNoSponsorsFound]: 'Inga sponsorer hittades',
    [TrKey.sponsorsFailedToSave]: 'Kunde inte spara sponsor',
    [TrKey.sponsorSaved]: 'Sponsorn sparades',
    [TrKey.sponsorUpdated]: 'Sponsorn uppdaterades',
    [TrKey.theSponsor]: 'sponsorn',
    [TrKey.sponsorsFailedToDelete]: 'Kunde inte radera sponsorn',
    [TrKey.sponsorDeleted]: 'Sponsorn raderades',
    [TrKey.sponsorName]: 'Sponsornamn',
    [TrKey.sponsorNameDescription]: 'Sponsorns fullständiga namn',
    [TrKey.sponsorUrl]: 'Sponsorlänk',
    [TrKey.sponsorUrlDescription]: 'Webbplatsen man når när man klickar på loggan',
    [TrKey.sponsorUrlPlaceholder]: 'Inkludera "https://"',
    [TrKey.sponsorLogo]: 'Sponsorlogotyp',
    [TrKey.sponsorLogoDescription]: 'Logotypen som visas för sponsorn',
  
    // Blog
    [TrKey.blogCouldNotSavePost]: 'Kunde inte spara nyhet',
    [TrKey.blogPostUpdated]: 'Nyheten uppdaterades',
    [TrKey.blogPostDuplicateTitle]: 'En annan nyhet har samma titel',
    [TrKey.blogPostSaved]: 'Nyheten sparades',
    [TrKey.theBlogPost]: 'nyheten',
    [TrKey.blogCouldNotDeletePost]: 'Kunde inte radera nyhet',
    [TrKey.blogPostDeleted]: 'Nyheten raderades',
    [TrKey.blogMissingWebsite]: 'Det finns ingen hemsida kopplad till detta konto. <a class="underline" href="mailto:info@bucketmedia.se">Kontakta oss</a> för att få hjälp.',
    [TrKey.blogTitle]: 'Nyhetsflöde',
    [TrKey.blogCreatePost]: 'Skapa nyhet',
    [TrKey.blogSearchPosts]: 'Sök nyheter',
    [TrKey.blogNoPostsFound]: 'Inga nyheter hittades',
    [TrKey.blogPost]: 'nyhet',
    [TrKey.blogPostTitleDescription]: 'Nyhetens titel',
    [TrKey.blogPostTitlePlaceholder]: 'Min titel',
    [TrKey.blogPostDateDescription]: 'Datumet som nyheten märks med',
    [TrKey.blogPostDatePlaceholder]: 'YYYY-MM-DD',
    [TrKey.blogPostSummaryDescription]: 'Kortfattad summering av nyheten',
    [TrKey.blogPostSummaryPlaceholder]: 'Summering',
    [TrKey.blogPostImageDescription]: 'Nyhetens huvudbild',
    [TrKey.blogPostBreadTextDescription]: 'Nyhetens textinnehåll',
    [TrKey.blogPostDelayPublishing]: 'Fördröj publicering',
    [TrKey.blogPostDelayPublishingUntil]: 'Fördröj publicering tills datum',
    [TrKey.blogPostRemoveDelayedPublishing]: 'Ta bort fördröjd publicering',
  
    // Calendar
    [TrKey.calendarCouldNotSaveEvent]: 'Kunde inte spara händelse',
    [TrKey.calendarEventSaved]: 'Händelsen sparades',
    [TrKey.calendarTheEvent]: 'händelsen',
    [TrKey.calendarCouldNotDeleteEvent]: 'Kunde inte radera händelse',
    [TrKey.calendarEventDeleted]: 'Händelsen raderades',
    [TrKey.calendarCouldNotUpdateEvent]: 'Kunde inte uppdatera händelse',
    [TrKey.calendarEventUpdated]: 'Händelsen uppdaterades',
    [TrKey.calendarRepeatStringDay]: 'Upprepas varje dag kl {startTime} - {endTime}',
    [TrKey.calendarRepeatStringWeek]: 'Upprepas varje vecka på {weekday} kl {startTime} - {endTime}',
    [TrKey.calendarTitle]: 'Kalender',
    [TrKey.calendarCreateEvent]: 'Skapa händelse',
    [TrKey.calendarNoEventsFound]: 'Inga händelser hittades',
    [TrKey.calendarEndTimeBeforeStartTime]: 'Sluttiden kan inte vara tidigare än starttiden',
    [TrKey.calendarEvent]: 'händelse',
    [TrKey.calendarEventSummaryLabel]: 'Beskrivning',
    [TrKey.calendarEventSummaryDescription]: 'Namnet på händelsen',
    [TrKey.calendarEventStartTimeLabel]: 'Starttid',
    [TrKey.calendarEventStartTimeDescription]: 'Tiden som händelsen startar',
    [TrKey.calendarEventEndTimeLabel]: 'Sluttid',
    [TrKey.calendarEventEndTimeDescription]: 'Tiden som händelsen slutar',
    [TrKey.calendarEventRepeatOptionsLabel]: 'Upprepa händelsen',
    [TrKey.calendarEventRepeatOptionsDescription]: 'Upprepa händelsen regelbundet',
    [TrKey.calendarEventRepeatEvery]: 'Upprepa varje',
    [TrKey.calendarRepeatOptionsUntil]: 'fram till',
    [TrKey.calendarRepeatOptionsCancelledDatesLabel]: 'Inställda datum',
    [TrKey.calendarRepeatOptionsCancelledDatesDescription]: 'Välj datum som inte ska visas i kalendern',
    [TrKey.calendarRepeatOptionsCancelledDatesPlaceholder]: 'Välj datum att ställa in',
    [TrKey.calendarLocationNameLabel]: 'Plats',
    [TrKey.calendarLocationNameDescription]: 'Namnet på platsen för händelsen',
    [TrKey.calendarLocationAddressLabel]: 'Adress',
    [TrKey.calendarLocationAddressDescription]: 'Adress som används för Google Maps',
    [TrKey.calendarBreadTextDescription]: 'Händelsens textinnehåll',
  
    // Media
    [TrKey.mediaRouteTitle]: 'Filer',
    [TrKey.mediaTypeAll]: 'Alla filer',
    [TrKey.mediaTypeImage]: 'Bilder',
    [TrKey.mediaTypeVideo]: 'Video',
    [TrKey.mediaTypePdf]: 'PDF',
    [TrKey.mediaFailedToFetchFiles]: 'Något gick fel när filerna hämtades',
    [TrKey.mediaNoFilesFound]: 'Inga filer hittades',
    [TrKey.mediaTheFile]: 'filen',
    [TrKey.mediaCouldNotDeleteFile]: 'Kunde inte radera filen',
    [TrKey.mediaFileDeleted]: 'Filen raderades',
    [TrKey.mediaUsageQuota]: 'Använt utrymme: {used} / {total} GB',
    [TrKey.mediaSearchFileName]: 'Sök filnamn',
    [TrKey.mediaUploadedAt]: 'Uppladdad',
    [TrKey.mediaUsed]: 'Används',
    [TrKey.mediaUsedIn]: 'Filen används i {usedIn}. Filer som används kan inte raderas',
    [TrKey.mediaFileTooLarge]: '{fileName} är för stor (max {maxSize})',
    [TrKey.mediaInvalidFile]: '{fileName} är inte en giltig fil',
    [TrKey.mediaFilesUploaded]: 'Filerna har laddats upp!',
    [TrKey.mediaUploadError]: 'Ett fel uppstod vid uppladdningen',
    [TrKey.mediaDropImages]: 'Släpp filerna för att ladda upp!',
    [TrKey.mediaDragNDrop]: 'Dra och släpp filer här, eller klicka för att välja filer',
    [TrKey.mediaMaxFileSize]: 'Max {maxSize} per fil',
    [TrKey.mediaUploading]: 'Laddar upp...',
  
    // Courses
    [TrKey.coursesRouteTitle]: 'Utbildningar',
    [TrKey.createCourse]: 'Skapa utbildning',
    [TrKey.coursesCourseDeleted]: 'Utbildningen raderades',
    [TrKey.coursesCourseCreated]: 'Utbildningen skapades',
    [TrKey.coursesFailedToDelete]: 'Kunde inte radera utbildningen',
    [TrKey.coursesFailedToCreate]: 'Kunde inte skapa utbildningen',
    [TrKey.theCourse]: 'utbildningen',
    [TrKey.courseNameDescription]: 'Namnet på utbildningen',
    [TrKey.courseNamePlaceholder]: 'Min utbildning',
    [TrKey.courseLastUpdated]: 'Senast uppdaterad',
    [TrKey.coursePublished]: 'Publicerad',
    [TrKey.courseNotPublished]: 'Ej publicerad',
  
    // Users
    [TrKey.usersRouteTitle]: 'Administratörer',
    [TrKey.usersCreateUser]: 'Lägg till administratör',
    [TrKey.usersTheUser]: 'administratören',
    [TrKey.usersFailedToDelete]: 'Kunde inte radera administratören',
    [TrKey.usersUserDeleted]: 'Administratören raderades',
    [TrKey.usersFailedToCreate]: 'Kunde inte skapa administratören',
    [TrKey.usersUserCreated]: 'Administratören skapades',
    [TrKey.usersFailedToUpdate]: 'Kunde inte uppdatera administratören',
    [TrKey.usersUserUpdated]: 'Administratören uppdaterades',
    [TrKey.usersLastLogin]: 'Senaste inloggning',
    [TrKey.usersFullNameDescription]: 'Både för- och efternamn',
    [TrKey.usersFullNamePlaceholder]: 'Förnamn Efternamn',
    [TrKey.usersEmailDescription]: 'Administören får en inbjudan till denna mailadress',
    [TrKey.usersYou]: 'Du',
  
  
    // CustomerUsers
    [TrKey.customerUsersRouteTitle]: 'Användare',
    [TrKey.customerUsersCreateUser]: 'Lägg till användare',
    [TrKey.customerUsersTheUser]: 'användaren',
    [TrKey.customerUsersFailedToDelete]: 'Kunde inte radera användaren',
    [TrKey.customerUsersUserDeleted]: 'Användaren raderades',
    [TrKey.customerUsersFailedToCreate]: 'Kunde inte skapa användaren',
    [TrKey.customerUsersUserCreated]: 'Användaren skapades',
    [TrKey.customerUsersFailedToUpdate]: 'Kunde inte uppdatera användaren',
    [TrKey.customerUsersUserUpdated]: 'Användaren uppdaterades',
    [TrKey.customerUsersFullNameDescription]: 'Både för- och efternamn',
    [TrKey.customerUsersFillNamePlaceholder]: 'Förnamn Efternamn',
    [TrKey.customerUsersEmailDescription]: 'Användaren får en inbjudan till denna mailadress',
  
    // Login
    [TrKey.loginTitle]: 'Logga in',
    [TrKey.loginEmailLabel]: 'Mailadress',
    [TrKey.loginPasswordLabel]: 'Lösenord',
    [TrKey.loginForgotPassword]: 'Glömt lösen?',
    [TrKey.loginLoggingIn]: 'Loggar in...',
    [TrKey.loginGenericError]: 'Fel mailadress eller lösenord',
  
    // Website analytics
    [TrKey.analyticsTitle]: 'Statistik',
    [TrKey.analyticsPeriod]: 'Statistikperiod',
    [TrKey.analyticsPeriodLastWeek]: 'Senaste veckan',
    [TrKey.analyticsPeriodLast2Weeks]: 'Senaste 2 veckorna',
    [TrKey.analyticsPeriodLast30Days]: 'Senaste 30 dagarna',
    [TrKey.analyticsOverview]: 'Översikt',
  
    // Website analytics single value
    [TrKey.analyticsTotalPageViews]: 'Totala sidvisningar',
    [TrKey.analyticsUniqueUsers]: 'Unika besökare',
    [TrKey.analyticsAvgEngagementTime]: 'Engagemangstid (snitt)',
    [TrKey.analyticsPageViewsLast5Minutes]: 'Sidvisningar senaste 5 min',
    [TrKey.analyticsUniqueUsersLast5Minutes]: 'Unika besökare senaste 5 min',
  
    // Website analytics graph
    [TrKey.analyticsUniqueUsersOverTime]: 'Unika besökare',
    [TrKey.analyticsUsersPerRoute]: 'Besökare per sida',
    [TrKey.analyticsUsersPerReferer]: 'Källa',
    [TrKey.analyticsUsersPerDevice]: 'Enhet',
    [TrKey.analyticsUsersPerPlatform]: 'Webbläsare',
    [TrKey.analyticsUsersPerOS]: 'Operativsystem',
    [TrKey.analyticsUsersPerVendor]: 'Enhetsmärke',
    [TrKey.analyticsUsersPerCountry]: 'Land',
    [TrKey.analyticsAvgEngagementTimeOverTime]: 'Genomsnittlig engagemangstid',
    [TrKey.analyticsAvgEngagementTimePerRoute]: 'Genomsnittlig engagemangstid per sida',
    
  
    // Delete confirmation
    [TrKey.deleteConfirmationText]: 'Fyll i följande i textfältet för att bekräfta:',
    [TrKey.deleteConfirmationMismatch]: 'Texten stämmer inte, försök igen.',

    // Confirm provider
    [TrKey.confirmProviderDefaultTitle]: 'Vänligen bekräfta',
    [TrKey.confirmProviderDefaultProceed]: 'Bekräfta',
  
    // Media input
    [TrKey.mediaInputSelectMedia]: 'Välj media',
    [TrKey.mediaInputChangeMedia]: 'Byt media',
    [TrKey.mediaInputRemoveMedia]: 'Ta bort media',
    [TrKey.imageInputSelectImage]: 'Välj bild',
    [TrKey.imageInputChangeImage]: 'Byt bild',
    [TrKey.imageInputRemoveImage]: 'Ta bort bild',

    // Editor
    [TrKey.editorHaveYouSaved]: 'Har du sparat dina ändringar?',
    [TrKey.editorRouteTitle]: 'Hemsideredigerare',
    [TrKey.editorBackToOverview]: 'Tillbaka till översikt',
    [TrKey.editorTabContent]: 'Innehåll',
    [TrKey.editorTabSettings]: 'Inställningar',
    [TrKey.editorTabSitemap]: 'Sidkarta',
    [TrKey.editorShowMenu]: 'Visa menyn',
    [TrKey.editorHideMenu]: 'Göm menyn',
    [TrKey.editorStaticComponents]: 'Statiska komponenter',
    [TrKey.editorStaticComponentsTooltip]: 'Klicka på komponenterna för att lägga till på sidan. Du kan bara använda en av varje komponent per sida.',
    [TrKey.editorAdd]: 'Lägg till',
    [TrKey.editorDynamicComponents]: 'Dynamiska komponenter',
    [TrKey.editorDynamicComponentsTooltip]: 'Dra komponenterna in till en sektion för att lägga till på sidan.',
    [TrKey.editorLeftColorsTitle]: 'Färg',
    [TrKey.editorLeftBaseColorLabel]: 'Grundfärg',
    [TrKey.editorLeftBaseColorDescription]: 'Er grundfärg',
    [TrKey.editorLeftBaseColorPlaceholder]: 'HEX-kod',
    [TrKey.editorLeftAccentColorLabel]: 'Accentfärg',
    [TrKey.editorLeftAccentColorDescription]: 'Er accentfärg',
    [TrKey.editorLeftAccentColorPlaceholder]: 'HEX-kod',
    [TrKey.editorLeftLogoTitle]: 'Logotyp',
    [TrKey.editorLeftLogoWideLabel]: 'Logotyp',
    [TrKey.editorLeftLogoWideDescription]: 'Bred version av er logotyp',
    [TrKey.editorLeftLogoSquareLabel]: 'Logotyp',
    [TrKey.editorLeftLogoSquareDescription]: 'Kvadratisk version av er logotyp',
    [TrKey.editorLeftContactTitle]: 'Kontaktuppgifter',
    [TrKey.editorLeftContactRecipientLabel]: 'Mottagare',
    [TrKey.editorLeftContactAdressLabel]: 'Adress',
    [TrKey.editorLeftContactPostalCodeLabel]: 'Postnummer',
    [TrKey.editorLeftContactPostalAreaLabel]: 'Postort',
    [TrKey.editorLeftContactPhoneLabel]: 'Telefon',
    [TrKey.editorLeftContactEmailLabel]: 'E-post',
    [TrKey.editorLeftNavBackgroundLabel]: 'Navigationsbakgrund',
    [TrKey.editorLeftNavBackgroundDescription]: 'Visas när sidan är scrollad',
    [TrKey.editorLeftSocialTitle]: 'Sociala medier',
    [TrKey.editorLeftContactFooterTextLabel]: 'Footertext',
    [TrKey.editorLeftContactFooterImageLabel]: 'Footerbild',
    [TrKey.editorLeftPageConfigTitle]: 'Sidkonfiguration',
    [TrKey.editorLeftPageConfigWebsiteBackgroundLabel]: 'Sidans bakgrund',
    [TrKey.editorLeftPageConfigWebsiteBackgroundDescription]: 'Gäller alla sidor på hemsidan',
    [TrKey.editorLeftPageConfigPageMaxWidthLabel]: 'Sidans maxbredd',
    [TrKey.editorLeftPageConfigPageMaxWidthDescription]: 'Gäller alla sidor på hemsidan',
    [TrKey.editorLeftPageConfigPageContentAnimationLabel]: 'Animationer',
    [TrKey.editorLeftPageConfigPageContentAnimationDescription]: 'Animerar in innehållet på sidan',
    [TrKey.editorBackgroundColorOptionStandard]: 'Standard',
    [TrKey.editorBackgroundColorOptionWhite]: 'Vit',
    [TrKey.editorBackgroundColorOptionOffWhite]: 'Off-white',
    [TrKey.editorLeftPageConfigPageMaxWidthOptionNormal]: 'Standard',
    [TrKey.editorLeftPageConfigPageMaxWidthOptionWide]: 'Bred',
    [TrKey.editorLeftPageConfigPageContentAnimationOptionNone]: 'Ingen animation',
    [TrKey.editorLeftPageConfigPageContentAnimationOptionFadeBottom]: 'Animera nedifrån',
    [TrKey.editorLeftSelectFooterPlaceholder]: 'Välj footer',
    [TrKey.editorLeftSelectNavPlaceholder]: 'Välj navigation',
    [TrKey.editorLeftSelectFontPlaceholder]: 'Välj typsnitt',
    [TrKey.editorPageFormPageNameMissing]: 'Sidnamn krävs',
    [TrKey.editorPageFormPageNameReserved]: 'Sidnamnet är reserverat, välj ett annat namn',
    [TrKey.editorPageFormPage]: 'sida',
    [TrKey.editorPageFormPageNameLabel]: 'Sidnamn',
    [TrKey.editorPageFormPageNameDescription]: 'Namnet på sidan',
    [TrKey.editorPageFormAuthOnlyLabel]: 'Endast för inloggade',
    [TrKey.editorPageFormAuthOnlyDescription]: 'Om du väljer detta alternativ kan endast inloggade användare se sidan',
    [TrKey.editorSitemapTopLevel]: 'toppnivån',
    [TrKey.editorSitemapEditing]: 'Redigerar',
    [TrKey.editorSitemapEditingTooltip]: 'Här kan du byta plats på sidor i navigationen, lägga till sidor, eller välja vilken sida du vill redigera.',
    [TrKey.editorSitemapBackTo]: 'Tillbaka till',
    [TrKey.editorSitemapNoPages]: 'Här finns inga undersidor ännu',
    [TrKey.editorSitemapAddPage]: 'Lägg till ny sida',
    [TrKey.editorTopPreviewMobile]: 'Förhandsvisa för mobil',
    [TrKey.editorTopPreviewDesktop]: 'Förhandsvisa för desktop',
    [TrKey.editorTopSaved]: 'Sparad',
    [TrKey.editorTopPublished]: 'Publicerad',
    [TrKey.editorTopPublishing]: 'Publicerar...',
    [TrKey.editorTopPublish]: 'Publicera',
    [TrKey.editorTopBack]: 'Lämna redigerare',
    [TrKey.editorNoPageSelected]: 'Ingen sida vald',
    [TrKey.editorEditingPage]: 'Du redigerar sidan "{pageName}"',
    [TrKey.editorPressEscapeToLeaveFullscreen]: 'Tryck escape för att lämna helskärmsläget',
    [TrKey.editorRemovePageConfirmationTitle]: 'Ta bort sida',
    [TrKey.editorRemovePageConfirmationText]: 'Är du säker på att du vill ta bort denna sida?',
    [TrKey.editorUnsavedChangesMessage]: 'Det finns osparade ändringar. Är du säker på att du vill lämna redigeraren?',
    [TrKey.editorUnsavedChangesTitle]: 'Osparat arbete',
    [TrKey.editorUnsavedChangesProceed]: 'Lämna utan att spara',
    [TrKey.editorUnsavedChangesAbort]: 'Stanna kvar',
    [TrKey.editorRightEditingTooltip]: 'Här kan du redigera innehållet och inställningarna för {contentType}',

    // Content type editors
    [TrKey.textSettings]: 'Textinställningar',
    [TrKey.marginOptionsTitle]: 'Marginaler',
    [TrKey.marginOptionsTopLabel]: 'Utrymme över',
    [TrKey.marginOptionsTopDescription]: 'Hur mycket utrymme som ska finnas över innehållet',
    [TrKey.marginOptionsBottomLabel]: 'Utrymme under',
    [TrKey.marginOptionsBottomDescription]: 'Hur mycket utrymme som ska finnas under innehållet',
    [TrKey.marginOptionsPlaceholder]: 'Välj ett värde',

    [TrKey.textAlignmentLabel]: 'Placering',
    [TrKey.textAlignmentDescription]: 'Textens linjering',
    [TrKey.textAlignmentOptionLeft]: 'Vänster',
    [TrKey.textAlignmentOptionRight]: 'Höger',
    [TrKey.textAlignmentOptionCenter]: 'Centrerad',
    [TrKey.textAlignmentOptionCenterMobile]: 'Centrerad på mobil', 

    [TrKey.fontWeightLabel]: 'Tjocklek',
    [TrKey.fontWeightDescription]: 'Textens tjocklek',
    [TrKey.fontWeightOptionThin]: 'Tunn',
    [TrKey.fontWeightOptionExtralight]: 'Extra lätt',
    [TrKey.fontWeightOptionLight]: 'Lätt',
    [TrKey.fontWeightOptionNormal]: 'Normal',
    [TrKey.fontWeightOptionMedium]: 'Medium',
    [TrKey.fontWeightOptionSemibold]: 'Semi bold',
    [TrKey.fontWeightOptionBold]: 'Bold',
    [TrKey.fontWeightOptionExtrabold]: 'Extra bold',
    [TrKey.fontWeightOptionBlack]: 'Extra extra bold',

    [TrKey.textColorLabel]: 'Färg',
    [TrKey.textColorDescription]: 'Textens färg',
    [TrKey.textColorOptionBlack]: 'Svart',
    [TrKey.textColorOptionWhite]: 'Vit',
    [TrKey.textColorOptionNeutral700]: 'Mörkgrå',
    [TrKey.textColorOptionPrimary400]: 'Primärfärg',
    [TrKey.textColorOptionPrimary300]: 'Primärfärg ljus',
    [TrKey.textColorOptionPrimary200]: 'Primärfärg ljusare',

    [TrKey.fontSizeLabel]: 'Storlek',
    [TrKey.fontSizeDescription]: 'Textens storlek',

    [TrKey.leadingLabel]: 'Radavstånd',
    [TrKey.leadingDescription]: 'Avståndet mellan raderna',

    [TrKey.textMaxWidthLabel]: 'Maximal bredd',
    [TrKey.textMaxWidthDescription]: 'Begränsar textens maximala bredd',
    [TrKey.textMaxWidthOptionNone]: 'Ingen',

    [TrKey.gridEditorLayoutLabel]: 'Layout',
    [TrKey.gridEditorLayoutDescription]: 'Hur sektionen delas upp',
    [TrKey.gridEditorLayoutPlaceholder]: 'Välj layout',
    [TrKey.gridEditorLayoutFullWidth]: 'Fullbredd',
    [TrKey.gridEditorGapLabel]: 'Mellanrum',
    [TrKey.gridEditorGapDescription]: 'Hur mycket mellanrum som finns mellan kolumnerna',
    [TrKey.gridEditorDirectionLabel]: 'Kolumnsortering',
    [TrKey.gridEditorDirectionDescription]: 'Vilken av kolumnerna som hamnar överst i mobilt läge',
    [TrKey.gridEditorDirectionLeftLabel]: 'Vänster först',
    [TrKey.gridEditorDirectionRightLabel]: 'Höger först',
    [TrKey.gridEditorTopLineLabel]: 'Övre linje',
    [TrKey.gridEditorTopLineDescription]: 'Lägger till en linje över sektionen',
    [TrKey.gridEditorBottomLineLabel]: 'Nedre linje',
    [TrKey.gridEditorBottomLineDescription]: 'Lägger till en linje under sektionen',
    [TrKey.gridEditorBackgroundLabel]: 'Bakgrund',
    [TrKey.gridEditorBackgroundOptionNone]: 'Ingen',
    [TrKey.gridEditorBackgroundOptionPrimary]: 'Primär',
    [TrKey.gridEditorBackgroundOptionAccent]: 'Accent',

    [TrKey.headerEditorTextLabel]: 'Rubriktext',
    [TrKey.headerEditorTextPlaceholder]: 'Min rubrik',

    [TrKey.imageCardsEditorCard]: 'Kort',
    [TrKey.imageCardsEditorHeader]: 'Rubrik',
    [TrKey.imageCardsEditorParagraph]: 'Text',
    [TrKey.imageCardsEditorButtonText]: 'Knapptext',
    [TrKey.imageCardsEditorButtonLink]: 'Knapplänk',

    [TrKey.bulletPointsEditorRow]: 'Rad',
    [TrKey.bulletPointsEditorText]: 'Text',

    [TrKey.svgInputLabel]: 'Ikon',
    [TrKey.svgInputPlaceholder]: 'Sök ikon',

    [TrKey.logoSectionEditorLogo]: 'Logotyp',
    [TrKey.logoSectionEditorCompanyName]: 'Företagsnamn',
    [TrKey.logoSectionEditorLink]: 'Länk',

    [TrKey.imageCollageEditorMainImage]: 'Huvudbild',
    [TrKey.imageCollageEditorSecondaryImage]: 'Sekundär bild',
    [TrKey.imageCollageEditorSettingsTitle]: 'Bildinställningar',
    [TrKey.imageCollageEditorLayoutLabel]: 'Layout',
    [TrKey.imageCollageEditorLayoutDescription]: 'Placering av den sekundära bilden',
    [TrKey.imageCollageEditorLayoutOptionBottomLeft]: 'Nere, vänster',
    [TrKey.imageCollageEditorLayoutOptionBottomRight]: 'Nere, höger',

    [TrKey.imageOptionsRoundedLabel]: 'Rundning',
    [TrKey.imageOptionsRoundedDescription]: 'Rundning av hörnen på bilden',
    [TrKey.imageOptionsRoundedOptionNone]: 'Ingen rundning',
    [TrKey.imageOptionsRoundedOptionMedium]: 'Liten rundning',
    [TrKey.imageOptionsRoundedOptionXLarge]: 'Större rundning',
    [TrKey.imageOptionsShadowLabel]: 'Skuggning',
    [TrKey.imageOptionsShadowDescription]: 'Skugga som ligger bakom bilden',
    [TrKey.imageOptionsShadowOptionNone]: 'Ingen skuggning',
    [TrKey.imageOptionsShadowOptionMedium]: 'Liten skuggning',
    [TrKey.imageOptionsShadowOptionXLarge]: 'Större skuggning',

    [TrKey.serviceCardEditorHeaderLabel]: 'Rubriktext',
    [TrKey.serviceCardEditorHeaderPlaceholder]: 'Min rubrik',
    [TrKey.serviceCardEditorButtonTextLabel]: 'Knapptext',
    [TrKey.serviceCardEditorButtonTextPlaceholder]: 'Min knapptext',
    [TrKey.serviceCardEditorButtonLinkLabel]: 'Knapplänk',
    [TrKey.serviceCardEditorButtonLinkPlaceholder]: '/min-sida',

    [TrKey.buttonEditorButtonTextLabel]: 'Knapptext',
    [TrKey.buttonEditorButtonTextPlaceholder]: 'Min knapp',
    [TrKey.buttonEditorButtonLinkLabel]: 'Knapplänk',
    [TrKey.buttonEditorButtonLinkDescription]: 'Dit knappen länkar',
    [TrKey.buttonEditorButtonLinkPlaceholder]: '/',
    [TrKey.buttonEditorButtonSettingsTitle]: 'Knappinställningar',
    [TrKey.buttonEditorColorLabel]: 'Färg',
    [TrKey.buttonEditorColorDescription]: 'Välj en färg för knappen',
    [TrKey.buttonEditorColorOptionCustomer]: 'Primär',
    [TrKey.buttonEditorColorOptionAccent]: 'Accent',
    [TrKey.buttonEditorColorOptionDark]: 'Mörk',
    [TrKey.buttonEditorColorOptionLight]: 'Ljus',
    [TrKey.buttonEditorTypeLabel]: 'Knapptyp',
    [TrKey.buttonEditorTypeDescription]: 'Välj typ för knappens utseende',
    [TrKey.buttonEditorTypeOptionFilled]: 'Fylld',
    [TrKey.buttonEditorTypeOptionOutline]: 'Linje',

    [TrKey.imageEditorImageLabel]: 'Bild',
    [TrKey.imageEditorImageTextLabel]: 'Bildtext',
    [TrKey.imageEditorImageTextDescription]: 'Text som visas under bilden',
    [TrKey.imageEditorImageSettingsTitle]: 'Bildinställningar',

    [TrKey.galleryEditorAddImage]: 'Lägg till bild',
    [TrKey.galleryEditorImageSettingsTitle]: 'Bildinställningar',

    [TrKey.formEditorNewField]: 'Nytt fält',
    [TrKey.formEditorContactEmailLabel]: 'Kontaktmail',
    [TrKey.formEditorContactEmailDescription]: 'Mailadressen som meddelanden skickas till',
    [TrKey.formEditorSubmitTextLabel]: 'Knapptext',
    [TrKey.formEditorSubmitTextDescription]: 'Text som visas på skicka-knappen',
    [TrKey.formEditorSuccessTextLabel]: 'Meddelande vid lyckad skickning',
    [TrKey.formEditorSuccessTextDescription]: 'Visas under formuläret när meddelandet skickats',
    [TrKey.formEditorSenderConfirmationEmailSubjectLabel]: 'Ämnesrad',
    [TrKey.formEditorSenderConfirmationEmailSubjectDescription]: 'Ämnesrad för bekräftelsemail till avsändaren',
    [TrKey.formEditorSenderConfirmationEmailBodyLabel]: 'Brödtext',
    [TrKey.formEditorSenderConfirmationEmailBodyDescription]: 'Textinnehåll i bekräftelsemail till avsändaren',
    [TrKey.formEditorSenderConfirmationEmailImageLabel]: 'Bild',
    [TrKey.formEditorSenderConfirmationEmailImageDescription]: 'Visas i sidfoten på mailet',
    [TrKey.formEditorFieldsTitle]: 'Fält',
    [TrKey.formEditorFieldNameLabel]: 'Namn på fältet',
    [TrKey.formEditorRequiredLabel]: 'Obligatoriskt',
    [TrKey.formEditorFieldTypePlaceholder]: 'Välj typ av fält',
    [TrKey.formEditorFieldTypeOptionText]: 'Text',
    [TrKey.formEditorFieldTypeOptionTextarea]: 'Textruta',
    [TrKey.formEditorFieldTypeOptionEmail]: 'E-post',
    [TrKey.formEditorFieldTypeOptionTel]: 'Telefon',
    [TrKey.formEditorFieldWidthPlaceholder]: 'Välj bredd',
    [TrKey.formEditorFieldWidthOptionFull]: 'Full bredd',
    [TrKey.formEditorFieldWidthOptionHalf]: 'Halv bredd',
    [TrKey.formEditorAddField]: 'Lägg till fält',

    [TrKey.videoHeroEditorContentTitle]: 'Innehåll',
    [TrKey.videoHeroEditorHeaderTextLabel]: 'Rubrik',
    [TrKey.videoHeroEditorHeaderTextPlaceholder]: 'Min rubrik',
    [TrKey.videoHeroEditorHeaderTextDescription]: 'Toppsektionens rubrik',
    [TrKey.videoHeroEditorParagraphTextLabel]: 'Underrubrik',
    [TrKey.videoHeroEditorParagraphTextPlaceholder]: 'Min underrubrik',
    [TrKey.videoHeroEditorParagraphTextDescription]: 'Toppsektionens underrubrik',
    [TrKey.videoHeroEditorCtaTextLabel]: 'Knapptext',
    [TrKey.videoHeroEditorCtaTextPlaceholder]: 'Min knapptext',
    [TrKey.videoHeroEditorCtaTextDescription]: 'Text på knappen',
    [TrKey.videoHeroEditorCtaLinkLabel]: 'Knapplänk',
    [TrKey.videoHeroEditorCtaLinkPlaceholder]: 'Inkludera "https://"',
    [TrKey.videoHeroEditorCtaLinkDescription]: 'Webbadress dit knappen leder',
    [TrKey.videoHeroEditorOverlayPercentageLabel]: 'Överskuggning',
    [TrKey.videoHeroEditorOverlayPercentageDescription]: 'Mörkar ned videon för att göra text mer läsbar',
    [TrKey.videoHeroEditorOverlayPercentageOptionNone]: 'Ingen överskuggning',
    [TrKey.videoHeroEditorVideoTitle]: 'Video',
    [TrKey.videoHeroEditorNoVideoSelected]: 'Ingen video vald',
    [TrKey.videoHeroEditorChangeVideo]: 'Byt video',
    [TrKey.videoHeroEditorSelectVideo]: 'Välj video',

    [TrKey.topSectionEditorHeaderTextLabel]: 'Rubrik',
    [TrKey.topSectionEditorHeaderTextPlaceholder]: 'Min rubrik',
    [TrKey.topSectionEditorHeaderTextDescription]: 'Toppsektionens rubrik',
    [TrKey.topSectionEditorAccentTitle]: 'Accent',
    [TrKey.topSectionEditorAccentLabel]: 'Accent för rubrik',
    [TrKey.topSectionEditorAccentDescription]: 'Skriv in en del av rubriken som ska få sidans accentfärg',
    [TrKey.topSectionEditorAccentPlaceholder]: 'Del av rubrik',
    [TrKey.topSectionEditorParagraphTextLabel]: 'Underrubrik',
    [TrKey.topSectionEditorParagraphTextPlaceholder]: 'Min underrubrik',
    [TrKey.topSectionEditorParagraphTextDescription]: 'Toppsektionens underrubrik',
    [TrKey.topSectionEditorCtaTextLabel]: 'Knapptext',
    [TrKey.topSectionEditorCtaTextPlaceholder]: 'Min knapptext',
    [TrKey.topSectionEditorCtaTextDescription]: 'Text på knappen',
    [TrKey.topSectionEditorCtaLinkLabel]: 'Knapplänk',
    [TrKey.topSectionEditorCtaLinkPlaceholder]: 'Inkludera "https://"',
    [TrKey.topSectionEditorCtaLinkDescription]: 'Webbadress dit knappen leder',
    [TrKey.topSectionEditorCtaColorLabel]: 'Knappfärg',
    [TrKey.topSectionEditorCtaColorDescription]: 'Knappens färg',
    [TrKey.topSectionCtaColorOptionPrimary]: 'Primär',
    [TrKey.topSectionCtaColorOptionAccent]: 'Accent',
    [TrKey.topSectionEditorOverlayTitle]: 'Övertoning',
    [TrKey.topSectionEditorOverlayColorLabel]: 'Övertoning färg',
    [TrKey.topSectionEditorOverlayColorDescription]: 'Färg som ligger över bildspelet',
    [TrKey.topSectionEditorOverlayColorPlaceholder]: 'Välj färg',
    [TrKey.topSectionOverlayColorOptionWhite]: 'Vit',
    [TrKey.topSectionOverlayColorOptionGray200]: 'Ljusgrå',
    [TrKey.topSectionOverlayColorOptionGray400]: 'Medelgrå',
    [TrKey.topSectionOverlayColorOptionGray600]: 'Mörkgrå',
    [TrKey.topSectionOverlayColorOptionBlack]: 'Svart',
    [TrKey.topSectionEditorOverlayStrengthLabel]: 'Övertoning styrka',
    [TrKey.topSectionEditorOverlayStrengthDescription]: 'Hur starkt övertoningen visas',
    [TrKey.topSectionEditorOverlayStrengthPlaceholder]: 'Välj styrka',
    [TrKey.topSectionOverlayStrengthOption02]: 'Svag',
    [TrKey.topSectionOverlayStrengthOption05]: 'Mellan',
    [TrKey.topSectionOverlayStrengthOption07]: 'Stark',
    [TrKey.topSectionOverlayStrengthOption1]: 'Fylld',
    [TrKey.topSectionEditorImageCarouselTitle]: 'Bildspel',
    [TrKey.topSectionEditorImageCarouselLabel]: 'Bildspel',
    [TrKey.topSectionEditorImageCarouselDescription]: 'Välj en eller flera bilder',
    [TrKey.topSectionEditorImageCarouselAddImage]: 'Lägg till bild',
    [TrKey.topSectionEditorHeightLabel]: 'Höjd',
    [TrKey.topSectionEditorHeightDescription]: 'Toppsektionens höjd',
    [TrKey.topSectionEditorHeightPlaceholder]: 'Välj ett värde',
    [TrKey.topSectionEditorHeightOptionLow]: 'Låg',
    [TrKey.topSectionEditorHeightOptionMedium]: 'Medel',
    [TrKey.topSectionEditorHeightOptionHigh]: 'Hög',
    [TrKey.topSectionEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.topSectionEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under toppsektionen',
    [TrKey.topSectionEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.quickLinksEditorMyLink]: 'Min länk',
    [TrKey.quickLinksEditorLink]: 'Länk',
    [TrKey.quickLinksEditorTextLabel]: 'Text',
    [TrKey.quickLinksEditorTextDescription]: 'Text som visas på länkkortet',
    [TrKey.quickLinksEditorLinkLabel]: 'Länkadress',
    [TrKey.quickLinksEditorLinkDescription]: 'Adressen dit länken ska peka',
    [TrKey.quickLinksEditorLinkPlaceholder]: 'Inkludera "https://"',
    [TrKey.quickLinksEditorLinkRemove]: 'Ta bort länk',
    [TrKey.quickLinksEditorLinkAdd]: 'Lägg till länk',
    [TrKey.quickLinksEditorColorLabel]: 'Färg',
    [TrKey.quickLinksEditorColorOptionWhite]: 'Vit',
    [TrKey.quickLinksEditorColorOptionPrimary]: 'Primär',
    [TrKey.quickLinksEditorColorOptionAccent]: 'Accent',

    [TrKey.accordionEditorTitleLabel]: 'Rubrik',
    [TrKey.accordionEditorTitleDescription]: 'Rubrik som syns innan en accordion expanderas',
    [TrKey.accordionEditorContentLabel]: 'Textinnehåll',
    [TrKey.accordionEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.accordionEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under sektionen',
    [TrKey.accordionEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.tipsBoxEditorTextLabel]: 'Textinnehåll',
    [TrKey.tipsBoxEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.tipsBoxEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under tipsrutan',
    [TrKey.tipsBoxEditorMarginBottomPlaceholder]: 'Välj ett värde',
    [TrKey.tipsBoxEditorAlignmentLabel]: 'Placering',
    [TrKey.tipsBoxEditorAlignmentPlaceholder]: 'Välj ett värde',
    [TrKey.tipsBoxEditorAlignmentOptionLeft]: 'Vänster',
    [TrKey.tipsBoxEditorAlignmentOptionCenter]: 'Mitten',

    [TrKey.documentEditorButtonTextLabel]: 'Knapptext',
    [TrKey.documentEditorButtonTextDescription]: 'Text som visas på knappen',
    [TrKey.documentEditorButtonTextPlaceholder]: 'Knapptext',
    [TrKey.documentEditorDocumentLabel]: 'Dokument',
    [TrKey.documentEditorNoDocumentSelected]: 'Inget dokument valt',
    [TrKey.documentEditorChangeDocument]: 'Byt dokument',
    [TrKey.documentEditorSelectDocument]: 'Välj dokument',
    [TrKey.documentEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.documentEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under dokumentknappen',
    [TrKey.documentEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.blogEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.blogEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under nyhetsflödet',
    [TrKey.blogEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.calendarEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.calendarEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under kalendern',
    [TrKey.calendarEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.contactFormEditorHeaderLabel]: 'Rubrik',
    [TrKey.contactFormEditorHeaderDescription]: 'Rubrik för formuläret',
    [TrKey.contactFormEditorInstructionLabel]: 'Instruktion',
    [TrKey.contactFormEditorInstructionDescription]: 'Vad användaren förväntas ange i formuläret.',
    [TrKey.contactFormEditorInstructionPlaceholder]: 'Kontakta oss gärna angående...',
    [TrKey.contactFormEditorResponseEmailLabel]: 'Mottagaradress',
    [TrKey.contactFormEditorResponseEmailDescription]: 'Mailadress dit formuläret skickas',
    [TrKey.contactFormEditorResponseEmailPlaceholder]: 'info@minforening.se',
    [TrKey.contactFormEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.contactFormEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under formuläret',
    [TrKey.contactFormEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.sponsorEditorTopTextLabel]: 'Rubrik',
    [TrKey.ytVideoEditorUrlLabel]: 'Youtube-länk',
    [TrKey.ytVideoEditorUrlDescription]: 'Klistra in hela Youtube-länken',
    [TrKey.ytVideoEditorMarginBottomLabel]: 'Utrymme under',
    [TrKey.ytVideoEditorMarginBottomDescription]: 'Hur mycket utrymme som ska finnas under videon',
    [TrKey.ytVideoEditorMarginBottomPlaceholder]: 'Välj ett värde',

    [TrKey.foodMenuEditorItemsTitle]: 'Artiklar',
    [TrKey.foodMenuEditorItemsTitleLabel]: 'Namn',
    [TrKey.foodMenuEditorItemsTitleDescription]: 'Namnet på artikeln',
    [TrKey.foodMenuEditorItemsPriceLabel]: 'Pris',
    [TrKey.foodMenuEditorItemsPriceDescription]: 'Priset på artikeln',
    [TrKey.foodMenuEditorItemsDescriptionLabel]: 'Beskrivning',
    [TrKey.foodMenuEditorItemsDescriptionDescription]: 'Beskrivningen på artikeln',
    [TrKey.foodMenuEditorItemsCategoryLabel]: 'Kategori',
    [TrKey.foodMenuEditorItemsCategoryDescription]: 'Kategoriserade artiklar kommer att grupperas tillsammans',

    // Content types
    [TrKey.contentTypeAccordion]: 'Accordion',
    [TrKey.contentTypeBlog]: 'Nyhetsflöde',
    [TrKey.contentTypeBullets]: 'Bulletpoints',
    [TrKey.contentTypeGallery]: 'Bildgalleri',
    [TrKey.contentTypeButton]: 'Knapp',
    [TrKey.contentTypeForm]: 'Formulär',
    [TrKey.contentTypeGrid]: 'Sektion',
    [TrKey.contentTypeHeader]: 'Rubrik',
    [TrKey.contentTypeImage]: 'Bild',
    [TrKey.contentTypeRichtext]: 'Textbox',
    [TrKey.contentTypeDocument]: 'Dokument',
    [TrKey.contentTypeSponsors]: 'Sponsorer',
    [TrKey.contentTypeTipsbox]: 'Tipsruta',
    [TrKey.contentTypeCalendar]: 'Kalender',
    [TrKey.contentTypeContactform]: 'Kontaktformulär',
    [TrKey.contentTypeQuicklinks]: 'Genvägar',
    [TrKey.contentTypeYtvideo]: 'Video',
    [TrKey.contentTypeTopsection]: 'Toppsektion',
    [TrKey.contentTypeVideoHero]: 'Video Hero',
    [TrKey.contentTypeImageCards]: 'Bildkort',
    [TrKey.contentTypeImageCollage]: 'Bildkollage',
    [TrKey.contentTypeLogoSection]: 'Logotyper',
    [TrKey.contentTypeServiceCard]: 'Erbjudande',
    [TrKey.contentTypeDSolutionsBadge]: 'DSolution badge',
    [TrKey.contentTypeFoodMenu]: 'Matmeny',
    [TrKey.contentTypeOpeningHours]: 'Öppettider',
    
    // Editor center
    [TrKey.editorCenterNoPageSelected]: 'Ingen sida vald',
    [TrKey.editorCenterSelectPage]: 'Välj en sida för att börja redigera',
    [TrKey.editorCenterMoveSectionUp]: 'Flytta sektion uppåt',
    [TrKey.editorCenterMoveSectionDown]: 'Flytta sektion neråt',
    [TrKey.editorCenterAddSectionAbove]: 'Lägg till sektion ovanför',
    [TrKey.editorCenterAddSectionBelow]: 'Lägg till sektion nedanför',
    [TrKey.editorCenterEditSection]: 'Redigera sektion',
    [TrKey.editorCenterDroppableText]: 'Dra innehåll hit',
    [TrKey.editorCenterDroppableHoverText]: 'Släpp innehåll här',

    // CMS Editor
    [TrKey.cmsEditorLeftHeader]: 'Modeller',
    [TrKey.cmsEditorCenterHeader]: 'Du redigerar {entryName}',
    [TrKey.cmsEditorNoActiveEntry]: 'Välj i vänstermenyn vad du vill redigera',

    // Ecommerce
    [TrKey.ecommerceRouteTitle]: 'E-handel',
  }
